import { QUOTE_CATS, label } from "@/lib/insurance";
import { money, fmtDate } from "@/lib/api";

export const InsuranceQuoteView = ({ quote, testId = "insurance-quote" }) => (
  <div data-testid={testId}>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="text-left text-xs uppercase tracking-wider text-[#56585E] border-b">
          <tr><th className="py-2 pr-3">Type</th><th className="py-2 pr-3">Description</th><th className="py-2 pr-3 text-right">Qty</th><th className="py-2 pr-3 text-right">Unit</th><th className="py-2 text-right">Total</th></tr>
        </thead>
        <tbody className="divide-y">
          {quote.items.map((it, i) => (
            <tr key={i}>
              <td className="py-2 pr-3 whitespace-nowrap text-[#56585E]">{label(QUOTE_CATS, it.category)}</td>
              <td className="py-2 pr-3">{it.description}</td>
              <td className="py-2 pr-3 text-right">{Number(it.quantity)}</td>
              <td className="py-2 pr-3 text-right whitespace-nowrap">{money(it.unit_price)}</td>
              <td className="py-2 text-right whitespace-nowrap">{money(it.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="mt-4 grid sm:grid-cols-2 gap-4">
      <div className="text-xs text-[#56585E] space-y-1">
        {Object.entries(quote.category_totals || {}).map(([k, v]) => <p key={k} className="flex justify-between max-w-[220px]"><span>{label(QUOTE_CATS, k)}</span><span>{money(v)}</span></p>)}
      </div>
      <div className="text-sm space-y-1 sm:text-right">
        <p>Subtotal <span className="font-semibold ml-2" data-testid={`${testId}-subtotal`}>{money(quote.subtotal)}</span></p>
        {quote.vat_enabled ? <p>VAT ({quote.vat_rate}%) <span className="font-semibold ml-2" data-testid={`${testId}-vat`}>{money(quote.vat)}</span></p> : <p className="text-[#56585E] text-xs">VAT not applied</p>}
        <p className="font-display text-xl font-extrabold text-[#020165]">Total <span className="ml-2" data-testid={`${testId}-total`}>{money(quote.total)}</span></p>
      </div>
    </div>
    {quote.notes && <div className="mt-4 rounded-xl bg-[#F4F4F4] p-4 text-sm"><p className="text-xs font-semibold uppercase tracking-wider text-[#56585E] mb-1">Notes from Accelary</p><p className="whitespace-pre-line" data-testid={`${testId}-notes`}>{quote.notes}</p></div>}
    {quote.sent_at && <p className="mt-3 text-xs text-[#56585E]">Issued {fmtDate(quote.sent_at)} · Version {quote.version || 1}</p>}
  </div>
);
